import React, { createContext,  } from 'react';

import { useTheme } from '@mui/material/styles';
import {
  Box,
  Paper,
} from '@mui/material';

import { Canvas } from './components/Canvas';

//-----------------------------------------------------------------
export function ImagePanel( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES] === STATE

  const theme = useTheme();

  const _styles = {
    container: {
      gridColumn : 'span 6'   ,
      overflow   : 'auto'     ,
      width      : '100%'     ,
      position   : 'relative' ,
      height     : '100%'     ,
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    }
  }


  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [METHOD]

  //#endregion 

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.container}>
        <Canvas />
      </Box>
    )
  }

  //#endregion
  
  return display();
}